import { INitrogenAnalysis } from "../../nitrogen/types"
import { calculateTotalSns, sortNitrogenAnalysis } from "../../nitrogen/utils"
import { FieldViewModel, groupBy, selectMany } from "../../omnia"
import { ISoilService, NitrogenAnalysisType } from "../../types"
import { AnalysisVM } from "../analysis-vm"

/// <reference path="../analysis-vm.ts" />

export class NitrogenAnalysisVM extends AnalysisVM<INitrogenAnalysis> {

    static create(svc: ISoilService, field: FieldViewModel, cropping: FieldViewModel, currentView: boolean) {

        let crops = field.croppings.filter(c => c.cropping.YearId <= svc.yearId);

        let allocations = selectMany(svc.getNitrogenAnalysis(true)
            .map(a => {

                let allocations = a.Allocations.filter(aa => aa.FieldId === field.fieldId);

                return allocations.map(aa => {
                    return {
                        analysis: a,
                        cropping: crops.find(c => c.croppingId === aa.CroppingId)
                    }
                }).filter(i => !!i.cropping);

            }));

        let analysis = selectMany(groupBy(allocations, a => a.cropping, a => a.croppingId).map(g => {

            let analysis = g.values.sort((c1, c2) => {

                return sortNitrogenAnalysis(g.key, c1.analysis, c2.analysis);

            });

            return analysis.map((a, index) => {

                return {
                    analysis: a.analysis,
                    cropping: g.key,
                    current: g.key.currentYear && (!g.key.cropping.NextCroppings || !g.key.cropping.NextCroppings.filter(c => c.YearId === svc.yearId).length) && !index
                }

            });

        }));

        let results = analysis.map(a => {

            let vm = new NitrogenAnalysisVM(a.cropping, a.analysis);

            vm.current = a.current;
            vm.selected = (cropping == a.cropping) && currentView;

            return vm;

        });

        return results;

    }


    private _sns: number;

    constructor(public cropping: FieldViewModel, analysis: INitrogenAnalysis) {
        super(analysis);
        this._sns = this.calculateSns();
    }

    private calculateSns() {
        let alloc = this.analysis.Allocations.find(a => a.CroppingId == this.cropping.croppingId);
        return calculateTotalSns(this.analysis, alloc);
    }

    get SNS() {
        return this._sns;
    }

    canEdit() {
        return !this.isVirtual();
    }

    isVirtual() {
        return (this.analysis.AnalysisType == NitrogenAnalysisType.FarmAssessment);
    }

}
